/* @generated */
// prettier-ignore
if (Intl.PluralRules && typeof Intl.PluralRules.__addLocaleData === 'function') {
  Intl.PluralRules.__addLocaleData({"data":{"categories":{"cardinal":["one","other","zero"],"ordinal":["few","one","other","zero"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    if (isOrdinal) {
        if (((((i === 2 || i === 3) || i === 4) || i === 5) || i === 6))
            return "few";
        if (i === 1)
            return "one";
        if (i === 0)
            return "zero";
    }
    else {
        if (n === 1)
            return "one";
        if (n === 0)
            return "zero";
    }
    return "other";
}},"locale":"blo"})
} else {
  (globalThis.__FORMATJS_PLURALRULES_DATA__ = globalThis.__FORMATJS_PLURALRULES_DATA__ || []).push({"data":{"categories":{"cardinal":["one","other","zero"],"ordinal":["few","one","other","zero"]},"fn":function(num, isOrdinal, exponent = 0) {
    const numStr = String(num);
    const parts = numStr.split(".");
    const integerPart = parts[0];
    const decimalPart = parts[1] || "";
    const n = Math.abs(parseFloat(numStr));
    const i = Math.floor(Math.abs(parseFloat(integerPart)));
    if (isOrdinal) {
        if (((((i === 2 || i === 3) || i === 4) || i === 5) || i === 6))
            return "few";
        if (i === 1)
            return "one";
        if (i === 0)
            return "zero";
    }
    else {
        if (n === 1)
            return "one";
        if (n === 0)
            return "zero";
    }
    return "other";
}},"locale":"blo"})
}
